import React from "react";
import {HiChevronDown} from "react-icons/hi";
import {useRegisterContext} from "../../context/ContextProvider";

const SpendStep4 = ({title, subtitle, brSubtitle}) => {
  const {activeStyle, setActiveStyle} = useRegisterContext();

  return (
    <form className="container spend__form-step4">
      <div className="unit__spend-container">
        <div className="unit__spend">
          <span className="nit__spend">{title}</span>
          <h4>
            {subtitle} <br /> {brSubtitle}
          </h4>
          <div className="unit__spend-value">
            <p>
              Monthly
              <HiChevronDown />
            </p>
            <p>
              UNIT
              <HiChevronDown />
            </p>
          </div>
        </div>
        <div className="unit__spend">
          <span className="nit__spend">Unit comsumed / month</span>
          <h4>
            1356.67 <br /> UNIT
          </h4>
          <div className="unit__spend-value">
            <p>
              Monthly
              <HiChevronDown />
            </p>
            <p>
              UNIT
              <HiChevronDown />
            </p>
          </div>
          {/* <button>Give Feedback</button> */}
        </div>
        <button onClick={() => setActiveStyle(activeStyle + 1)}>
          Give Feedback
        </button>
        <button disabled>Buy Unit</button>
      </div>
    </form>
  );
};

export default SpendStep4;
